import { jsonp } from '@ifeng-fe/ui_base';

export const getAwardList = async () => {
    return await jsonp('https://shankapi.ifeng.com/feedflow/coopdoc/doc_6e1b0b46ecbe2f5f7b305e2467b2068b/info/cb?callback=cb', {
      jsonpCallback: 'cb',
      cache: false,
    });
};

export const getcheduleListNew = () => {
    return jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_f29d562ad8c76fcbd6a0ada43a92f86e/info/getcheduleListNew',
        {
            jsonp: 'callback',
            jsonpCallback: 'getcheduleListNew',
            cache: false,
        },
    );
};

export const getcheduleListTips = () => {
    return jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_715e031c716fececf0092e7aad620bf7/info/getcheduleListTips',
        {
            jsonp: 'callback',
            jsonpCallback: 'getcheduleListTips',
            cache: false,
        },
    );
};

export const getIconList = () => {
    return jsonp(
        'https://shankapi.ifeng.com/feedflow/coopdoc/doc_2520bd7d61ab0fda48c7f0f9aef089e5/info/getIconList',
        {
            jsonp: 'callback',
            jsonpCallback: 'getIconList',
            cache: false,
        },
    );
};
